import { NgModule } from '@angular/core';

import { KeyboardClickDirective } from './keyboard-click.directive';

/**
 * Angular module that provides keyboard accessibility functionality for interactive elements.
 *
 * @remarks
 * Exports the {@link KeyboardClickDirective} which enables click, Enter, and Space key events
 * for accessibility compliance. This module should be imported in any module that needs
 * to add keyboard navigation support to non-button elements or enhance existing interactive
 * elements with keyboard accessibility.
 *
 * @example
 *
 * ```typescript
 * import { KeyboardClickModule } from '@backbase/ui-ang/keyboard-click-directive';
 *
 * @NgModule({
 *   imports: [KeyboardClickModule],
 *   // ... other module configuration
 * })
 * export class CollapsibleCardModule {}
 * ```
 */
@NgModule({
  declarations: [KeyboardClickDirective],
  exports: [KeyboardClickDirective],
})
export class KeyboardClickModule {}
